import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function DemoGuide() {
  const [subject, setSubject] = useState("");
  const [grade, setGrade] = useState("");
  const [profile, setProfile] = useState("");
  const [loading, setLoading] = useState(false);
  const [guide, setGuide] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!subject) return toast.error("Subject required");
    setLoading(true); setGuide("");
    try {
      const { data } = await api.post("/ai/demo-guide", { subject, grade, student_profile: profile });
      setGuide(data.guide);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-6" data-testid="demo-guide-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-neutral-500 mb-1">/ how to crack the demo</div>
        <h1 className="font-display font-bold text-3xl tracking-tighter">Demo class playbook</h1>
        <p className="text-sm text-neutral-600 mt-1">A custom 5-minute script + parent communication template. 5 credits.</p>
      </div>
      <form onSubmit={submit} className="bg-white border border-neutral-200 p-6 grid sm:grid-cols-3 gap-3">
        <input className={inp} required placeholder="Subject *" value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="demo-subject" />
        <input className={inp} placeholder="Grade" value={grade} onChange={(e) => setGrade(e.target.value)} />
        <input className={inp} placeholder="Student profile" value={profile} onChange={(e) => setProfile(e.target.value)} />
        <button type="submit" disabled={loading} data-testid="demo-generate" className="sm:col-span-3 bg-[#0A0C10] text-white font-bold py-3 inline-flex items-center justify-center gap-2 disabled:opacity-60">
          <Sparkles size={16} /> {loading ? "Building…" : "Generate playbook"}
        </button>
      </form>
      {guide && (
        <div className="bg-white border border-neutral-200 p-6">
          <pre className="whitespace-pre-wrap font-mono text-[13px] text-neutral-800">{guide}</pre>
        </div>
      )}
    </div>
  );
}

const inp = "w-full bg-white border border-neutral-300 px-4 py-2.5 focus:ring-2 focus:ring-[#002FA7] focus:border-[#002FA7] outline-none";
